import {CONFIG} from '../../appConfig';
import STATE from '../../constants/state';

const CONTRACT = 'contract/';

export default {
  /**
   * @desc Request and store contract details by contract code
   * @param {Object} data {endpoint, params}
   * @returns {Object}
   * @memberof services.gma.contract
   * @example
   * const data = {
   *  endpoint: {
   *    code, // *(String)* i.e. 'MARLOW3'
   *  }
   * }
   * services.gma.contract.details(data);
   */
  details(data = {}) {
    const {endpoint = {}, params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${CONTRACT}details/${endpoint.code}`,
      params,
      statePath: STATE.GMA.CONTRACT.DETAILS.concat([endpoint.code])
    };
  }
};
